import { Outlet, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute/PrivateRoute';
import Reports from './Reports';

export const ReportsRouter = (
  <Route path="reports" element={<Outlet />}>
    <Route
      index
      element={(
        <PrivateRoute roles={['Admin']}>
          <Reports />
        </PrivateRoute>
      )}
    />

  </Route>
);
